var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("card-header", {
            attrs: { title: _vm.$router.currentRoute.meta.title }
          }),
          _c(
            "form",
            {
              attrs: { role: "form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.change($event)
                }
              }
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm.serverError
                      ? _c("div", { staticClass: "alert alert-danger" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                          ]),
                          _vm._v(" " + _vm._s(_vm.serverError) + " ")
                        ])
                      : _vm._e()
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-password", {
                      attrs: {
                        options: {
                          id: "current_password",
                          label: "current_password",
                          error: _vm.fieldErrors.oldPassword
                        }
                      },
                      model: {
                        value: _vm.current_password,
                        callback: function($$v) {
                          _vm.current_password = $$v
                        },
                        expression: "current_password"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-password", {
                      attrs: {
                        options: {
                          id: "new_password",
                          label: "new_password",
                          error: _vm.fieldErrors.newPassword
                        }
                      },
                      model: {
                        value: _vm.new_password,
                        callback: function($$v) {
                          _vm.new_password = $$v
                        },
                        expression: "new_password"
                      }
                    }),
                    _c("input-password", {
                      attrs: {
                        options: {
                          id: "new_password_confirmed",
                          label: "new_password_confirmed",
                          error: _vm.fieldErrors.newPasswordConfirmed
                        }
                      },
                      model: {
                        value: _vm.new_password_confirmed,
                        callback: function($$v) {
                          _vm.new_password_confirmed = $$v
                        },
                        expression: "new_password_confirmed"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "card-footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-neutral btn-sm",
                          attrs: { to: { name: _vm.routePrefix + ".me" } }
                        },
                        [_c("i", { staticClass: "fa fa-arrow-left" })]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "submit", disabled: _vm.loading }
                        },
                        [
                          _vm.loading
                            ? _c("span", {
                                staticClass: "spinner-border spinner-border-sm"
                              })
                            : _vm._e(),
                          _c("i", { staticClass: "fa fa-save" })
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }